import { IconButton } from 'components/IconButton/IconButton'
import { RightPanel } from 'almanac-ui/icons'
import { ButtonSize } from 'components/Button/Types'
import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'

interface Props {
  size?: ButtonSize
  onPress?: (isLocked: boolean) => void
}

export const RightColumnLockButton = observer(({ size = 'md', onPress }: Props) => {
  const layout = useLayout()

  return (
    <IconButton
      size={size}
      data-testid="unlock-right-rail-button"
      onPress={() => {
        const locked = !layout.rightColumnLocked
        onPress?.(locked)
        layout.setRightColumnLocked(locked)
      }}
      aria-label={layout.rightColumnLocked ? 'Close' : 'Open'}
    >
      <RightPanel />
    </IconButton>
  )
})
